import Image from "next/image";
import React, { useState } from "react";
import { ButtonProps } from "@/types/ui-kit/buttons";

export const FollowButton: React.FC<ButtonProps> = ({ iconPath, onClick }) => {
  const icon = iconPath ? iconPath : "/assets/images/icons/success-dark.svg";
  const [followed, setFollowed] = useState(false);
  const toggleFollow = () => {
    setFollowed(!followed);
    onClick?.();
  };

  return (
    <>
      {followed ? (
        <button onClick={toggleFollow}>
          <Image src={icon} alt="Odebírat" width={20} height={20} />
        </button>
      ) : (
        <button
          onClick={toggleFollow}
          className="cursor-pointer justify-between rounded-2xl bg-dark px-4 py-1 font-sans text-sm text-white transition ease-in hover:bg-orange"
        >
          <span>Odebírat</span>
        </button>
      )}
    </>
  );
};
